import {AxiosResponse, ipmQueryClient, referralsSplit} from "@twigsby/client-data";
import {IpmRqKeys} from "@twigsby/client-data/lib/Wrappers/ReactQuery/CacheKeys";
import {
    AlertBanner,
    ButtonSubmit,
    ColourSolid,
    ComboBoxControl,
    Modal,
    ModalType,
} from "@twigsby/frontend-framework";
import {FormProvider, useForm} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React, {useEffect, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {ErrorMapper} from "../../ErrorMapper";

interface ChangeSplitModalType extends ModalType {
    currentSplit: number;
}

const ChangeSplitModal = (props: ChangeSplitModalType) => {
    const{ t } = useTranslation();

    const [ splitError, setSplitError ] = useState<AxiosResponse>();

    const formMethods = useForm({
        defaultValues: {
            split: props.currentSplit,
        },
        mode: "onChange"
    });

    const {
        handleSubmit,
        setValue,
        reset,
        formState,
    } = formMethods;

    const HandleSplitChange = (data: any) => {
        referralsSplit(data.split).then(r => {
            props.closeCallback();
            ipmQueryClient.invalidateQueries([IpmRqKeys.REFERRALS_SUMMARY]).then(() => null);
        }).catch((e) => {
            setSplitError(e);
        })
    }

    return (
        <Modal title={t('settings.referralsSplit.title')} isOpen={props.isOpen} closeCallback={props.closeCallback}>
            <FormProvider {...formMethods}>
                <form onSubmit={handleSubmit(HandleSplitChange)}>
                    <fieldset className={'flex-column flex-gap-md'}>

                        {splitError?.data && (
                            <ErrorMapper errorResponse={splitError} />
                        )}

                        <ComboBoxControl
                            name={'split'}
                            placeholder={t('settings.referralsSplit.controls.splitPlaceholder')}
                            valueType={'number'}
                            singleSelection={true}
                            forwardValueCallback={(e) => setValue('split', e)}
                            data={[
                                {
                                    label: '0%',
                                    value: 0
                                },
                                {
                                    label: '25%',
                                    value: 25
                                },
                                {
                                    label: '50%',
                                    value: 50
                                },
                                {
                                    label: '75%',
                                    value: 75
                                },
                                {
                                    label: '100%',
                                    value: 100
                                }
                            ]}
                            defaultValues={props.currentSplit ? [props.currentSplit]: undefined}
                        />

                        <ButtonSubmit
                            title={t('settings.referralsSplit.actions.save')}
                            colour={ColourSolid.Primary}
                            fullWidth={true}
                            disabled={!formState.isValid || formState.isSubmitting}
                        />
                    </fieldset>
                </form>
            </FormProvider>
        </Modal>
    )
}

export default ChangeSplitModal
